<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  
========================================================================================== -->

<template>
  <div>
    <!-- SM - OPEN SIDEBAR BUTTON -->
    <div id="bigScreenDiv">
      <b-navbar
        toggleable="lg"
        type="dark"
        variant="primary"
        id="horizontal_navbar"
      >
        <!-- <b-navbar-brand href="/#/dashboard">
          {{ company + " customer portal" }}</b-navbar-brand
        > -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown :text="userNameComputed" right>
            <b-dropdown-item
              v-if="showCustomer"
              href="/#/account-settings"
              variant="dark"
              >Settings</b-dropdown-item
            >
            <b-dropdown-item @click="signOut()" variant="dark"
              >Sign Out</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </div>
    <div class="d-inline" id="horizontal_navbar_div">
      <b-navbar
        toggleable="lg"
        type="dark"
        variant="primary"
        id="horizontal_navbar"
      >
        <b-navbar-brand href="/#/dashboard">
          <img
            v-if="logo"
            :src="logo"
            class="d-inline-block align-top"
            width="50"
            height="50"
          />
          <!-- <span v-if="logo"> Customer Portal </span> -->
          <span v-if="!logo">
            {{ company }}
          </span>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item href="/#/dashboard">Dashboard</b-nav-item>
            <b-nav-item v-if="!showCustomer" href="/#/user-customers"
              >Choose Customer</b-nav-item
            >
            <b-nav-item v-if="userCustomer" href="/#/add-order"
              >Add Order</b-nav-item
            >
            <b-nav-item v-if="userCustomer" href="/#/orders">Orders</b-nav-item>
            <b-nav-item v-if="showCustomer" href="/#/account-settings"
              >Settings</b-nav-item
            >
            <b-nav-item @click="signOut()">Sign Out</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import "@/helpers/string";
export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      company: "",
      logo: "",
    };
  },
  mounted() {
    this.getUserDetails();
  },
  computed: {
    userNameComputed() {
      return this.$store.getters.userNameDomain.split(".").length > 1
        ? this.$store.getters.userNameDomain.split(".")[1]
        : this.$store.getters.userCustomer === ""
        ? this.$store.getters.userNameDomain
        : this.$store.getters.userCustomer;
    },
    userCustomer() {
      return (
        this.$store.getters.userCustomer !== "" ||
        this.$store.getters.userRole.includes("Customer")
      );
    },
    showCustomer() {
      return this.$store.getters.userRole.includes("Customer");
    },
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor != "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor != "#fff" && this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default") return "navbar-default";
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    signOut() {
      // this.$root.$data.user = "NOT_SET";
      // this.$root.$data.email = "NOT_SET";
      // this.$root.$data.company = "NOT_SET";
      let endPoint = "Rest/logOut";

      const urlCheckPermission = new URL(
        `${process.env.VUE_APP_BASE_URL}${endPoint}`
      );

      urlCheckPermission.searchParams.append(
        "APIKey",
        process.env.VUE_APP_API_KEY
      );
      return fetch(urlCheckPermission.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then((r) => {
        if (r.status == 200) {
          if (this.$store.getters.userRole.includes("Customer")) {
            this.$router.push({
              name: "login",
              query: {
                company: this.$store.getters.userNameDomain.split(".")[0],
              },
            });
          } else {
            this.$router.push({ name: "login" });
          }
          this.$store.commit("UPDATE_USER_CUSTOMER", "");
          this.$store.commit("UPDATE_USER_ROLE", "");
          this.$store.commit("UPDATE_USER_NAME_DOMAIN", "");
        }
      });
    },
  },
};
</script>

<style>
#horizontal_navbar_div {
  visibility: hidden;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='white' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E") !important;
}

.navbar-toggler {
  border-color: white !important;
}

.navbar {
  background-color: rgb(61, 176, 238) !important;
  /* background-color: white !important; */
}

.nav-item.nav-item.nav-item a {
  color: white;
}

@media screen and (max-width: 960px) {
  #horizontal_navbar_div {
    visibility: visible;
  }

  #bigScreenDiv {
    visibility: hidden;
    height: 0px;
  }
}
</style>